export const PROMO_ERROR_MESSAGE = 'Invalid promo code.';

export const STEP_TWO_SUBHEADING = {
  whitelisted: "Looks like you're already on the list. Choose a password below and you're in.",
  promo: "Your code worked — choose a password and you're good to go.",
};

/** Route user based on /auth/signup/check result. Returns 'promo_error' to show inline. */
export function routeFromSignupCheck(result, { email, promoCode, navigate, setAccessReason, setStep }) {
  if (result.account_exists) {
    navigate('/login', { state: { email, existingAccount: true } });
    return 'routed';
  }

  if (result.has_access) {
    setAccessReason(result.whitelisted || !promoCode.trim() ? 'whitelisted' : 'promo');
    setStep('create');
    return 'routed';
  }

  if (result.promo_error) {
    return 'promo_error';
  }

  navigate(`/request-access?email=${encodeURIComponent(email)}`);
  return 'routed';
}

export function parseApiError(err, fallback = 'Something went wrong. Please try again.') {
  const detail = err?.response?.data?.detail;
  if (typeof detail === 'string') return detail;
  if (Array.isArray(detail)) return detail.map((item) => item.msg || item.message).join(', ');
  if (detail && typeof detail === 'object') return JSON.stringify(detail);
  if (err?.message) return err.message;
  return fallback;
}

export function isExistingAccountError(message) {
  return /already registered|already exists|user already/i.test(message);
}
